<template>
  <Icon
    :icon="iconFor(status)"
    :iconColor="colorFor(status)"
    :tooltipText="labelFor(status)"
    margin=""
  />
</template>

<script>
import { EudrBatchStatus } from '@/utils/Enumerations.js'

export default {
  name: 'EudrBatchStatusIcon',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    status: { type: Number, default: undefined }
  },

  methods: {
    iconFor (status) {
      return EudrBatchStatus.forInt(status)?.details.icon
    },

    colorFor (status) {
      return EudrBatchStatus.forInt(status)?.details.color
    },

    labelFor (status) {
      return EudrBatchStatus.fromInt(status)
    }
  }
}
</script>
